<div class="flex flex-col items-center justify-center min-h-[70vh] px-4 py-12 text-center bg-neutral-50/80 dark:bg-zinc-900/50 rounded-2xl border border-neutral-200/80 dark:border-zinc-700/80 mx-4">
    <div class="flex items-center justify-center w-20 h-20 rounded-2xl bg-amber-500/15 text-amber-600 dark:text-amber-400 ring-2 ring-amber-500/20 dark:ring-amber-400/20 mb-6">
        <mat-icon class="icon-size-12" [svgIcon]="'heroicons_outline:shield-exclamation'"></mat-icon>
    </div>
    <h1 class="text-2xl sm:text-3xl font-bold text-neutral-900 dark:text-white tracking-tight">
        No access to modules
    </h1>
    <p class="mt-3 max-w-md text-base text-neutral-600 dark:text-neutral-400">
        Your account does not have permission to use any module yet. Please contact your administrator or super admin to assign you the required roles and permissions.
    </p>
    <p class="mt-2 text-sm text-neutral-500 dark:text-neutral-500">
        Once permissions are granted, refresh this page or sign in again to see your modules.
    </p>
    <div class="mt-8 flex flex-wrap items-center justify-center gap-3">
        <a mat-flat-button color="primary" routerLink="/sign-out" class="!rounded-xl">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
            <span class="ms-2">Sign out</span>
        </a>
    </div>
</div>
